import type { WhyForYou as WhyForYouData } from "../types";

/**
 * "Why this signal for you" card (Reskin Session C). Ink-tinted card above the
 * intelligence zone, joining the assign context note and the capability-match
 * line. Hidden when both are absent (per-section graceful degradation).
 */
export function WhyForYou({
  why,
}: {
  why: WhyForYouData | null;
}): JSX.Element | null {
  if (!why || (!why.contextNote && !why.capabilityMatch)) return null;
  const text = [why.contextNote, why.capabilityMatch]
    .filter((s): s is string => Boolean(s))
    .join(" ");
  return (
    <div className="sxr-why">
      <p className="sxr-why-eyebrow">Why this signal for you</p>
      <p className="sxr-why-text">{text}</p>
    </div>
  );
}
